/*
 * Copyright (c) 2024. Devtron Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// NOTE: This API is used to check if the license is valid or not at APP.TSX level

import {
    DevtronLicenseDTO,
    DevtronLicenseInfo,
    get,
    parseDevtronLicenseData,
    ROUTES,
} from '@devtron-labs/devtron-fe-common-lib'

// Only gives complete response if the license is invalid else return only fingerprint
export const getDevtronLicenseInfo = async (): Promise<DevtronLicenseInfo> => {
    const { result } = await get<DevtronLicenseDTO>(ROUTES.LICENSE_DATA, { preventLicenseRedirect: true })
    return parseDevtronLicenseData(result)
}
